import DOMUtils from "./dom-utils";
import MessagePoster from "./message-poster";

export default class Scroller {
  #useScrollToMessages;
  #paused;
  #defaultPadding;

  constructor(useScrollToMessages = false) {
    this.#useScrollToMessages = useScrollToMessages;
    this.#paused = false;
    this.#defaultPadding = 25;
  }

  pause() {
    this.#paused = true;
  }

  unpause() {
    this.#paused = false;
  }

  scrollToElemTop($elem, padding) {
    if (this.#paused) {
      return;
    }

    padding = padding ?? this.#defaultPadding;

    // Wait until the next frame to scroll to allow time for redraw/reflow 
    setTimeout(() => {
      const top = DOMUtils.getElemTop($elem);

      // Account for a fixed/sticky navbar
      const $navbar = $("#nav-wrap");
      const pos = $navbar.css("position");
      if (pos == "fixed" || pos == "sticky") {
        padding += $navbar.outerHeight();
      }

      this.scrollTo(top, padding);
    }, 0);
  }

  scrollTo(top, padding) {
    if (this.#paused) {
      return;
    }

    padding = padding ?? this.#defaultPadding;

    if (this.#useScrollToMessages) {
      MessagePoster.postScrollTo(top, padding);
    } else {
      this.#scrollWindowTo(top - padding);
    }
  }

  #scrollWindowTo(top) {
    if (this.#paused) {
      return;
    }

    window.scroll({ top, behavior: "smooth" });
  }
}